import styled, { css } from 'styled-components';
import { em, rem } from 'styles';

export const PageContainer = styled.div`
  padding: ${em(12)};
`;

export const Layout = styled.div`
  display: grid;
  grid-template-columns: ${em(260)} 1fr ${em(340)};
  gap: ${em(16)};
  align-items: start;

  ${({ theme }) =>
    theme.breakpoints.sx(css`
      grid-template-columns: 1fr;
    `)}
`;

export const Center = styled.main`
  display: flex;
  flex-direction: column;
  gap: ${em(12)};
  min-width: 0;
`;

export const Side = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${em(12)};
  min-width: 0;
`;

export const PageMessage = styled.p`
  ${({ theme }) => css`
    margin: ${em(40)} 0;
    text-align: center;
    font-size: ${rem(15)};
    color: ${theme.colors.nature.n3};
  `}
`;

export const RetryRow = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${em(12)};
    color: ${theme.colors.danger};
    font-size: ${rem(13)};
  `}
`;
